/**
 * Constants for Supabase Realtime timestamp broadcasts.
 * These table names must match the database table names in the triggers.
 */

// Table names for timestamp broadcasts
export const TIMESTAMP_TABLES = {
  /** Network-specific timestamps (network, variableState, assumption, etc.) */
  NETWORK_TIMESTAMPS: 'last_network_update_timestamps',
  /** Global network list timestamps (for network create/update/delete) */
  NETWORKS_LIST: 'last_networks_update_timestamp',
  /** View-specific timestamps */
  VIEWS: 'last_views_update_timestamp',
} as const

// Direct table broadcasts (not using timestamp tables)
export const DIRECT_TABLE_BROADCASTS = {
  /** Optimization jobs table - broadcasts directly */
  OPTIMIZATION_JOBS: 'optimization_jobs',
  /** Notification table - broadcasts directly, drives the in-app bell */
  NOTIFICATION: 'notification',
  /** Feature-flag tables - broadcast directly so flags re-resolve live (KBE-741) */
  FEATURE_FLAG: 'feature_flag',
  FEATURE_FLAG_USER: 'feature_flag_user',
} as const

export type TimestampTableName =
  (typeof TIMESTAMP_TABLES)[keyof typeof TIMESTAMP_TABLES]

// Topics are the same as table names for our broadcast channels
export const GLOBAL_TOPICS = [
  TIMESTAMP_TABLES.NETWORKS_LIST,
  DIRECT_TABLE_BROADCASTS.OPTIMIZATION_JOBS,
  DIRECT_TABLE_BROADCASTS.NOTIFICATION,
  DIRECT_TABLE_BROADCASTS.FEATURE_FLAG,
  DIRECT_TABLE_BROADCASTS.FEATURE_FLAG_USER,
] as const

export const NETWORK_SPECIFIC_TOPICS = [
  TIMESTAMP_TABLES.NETWORK_TIMESTAMPS,
  TIMESTAMP_TABLES.VIEWS,
] as const

export type TopicName =
  (typeof GLOBAL_TOPICS)[number] | (typeof NETWORK_SPECIFIC_TOPICS)[number]

// Broadcast message structure from Supabase Realtime
export type BroadcastMessage = {
  event?: string
  type?: string
  payload?: {
    table?: string
    schema?: string
    operation?: 'INSERT' | 'UPDATE' | 'DELETE'
    record?: Record<string, unknown> | null
    old_record?: Record<string, unknown> | null
  }
}
